import { Button, Form, Input, message, Modal } from 'antd'
import { useTranslation } from 'react-i18next';
import { authFetch } from '../../../../../common/request/authFetch';
import { useAuth } from '../../../../../store/AuthContext/AuthContext';
import { CheckOutlined } from '@ant-design/icons';

export const SummaryEdit = (props: {postScheduledId : string[], summary: string,	onFinish: () => void}) => {

    const { projectGroup } = useAuth();
    const [scheduleDateForm] = Form.useForm();
    const { t } = useTranslation();    
    
    const submitEditSummary = async(formValues: {summary: string}) => {

        const requestBody = {          
          summary: formValues.summary,          
        };

        await authFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${projectGroup.group}/post-scheduled/${props.postScheduledId}/summary`, { method: 'PATCH', data: requestBody })
        .then((res) => {          
          if (res) {
            message.success('Fecha de programación cambiada correctamente', 3);
            props.onFinish();            
          } else {
            message.error('Error al cambiar la fecha de programación', 3)
          }
    });
  
    }
    return (
      <div style={{ display: 'flex', alignItems: 'center', height: '100%', width: '100%' }}>
          
        <Form
          form={scheduleDateForm}
          onFinish={(values) => submitEditSummary(values)}
          initialValues={{ summary: props.summary }}
          style={{ width: '850%' }}>

          <Form.Item
            name={'summary'}
            rules={[
              { 
                required: true, 
                message: t('view.forms.fields.details.required') as string 
              },
              { 
                max: 1500, 
                message: 'El máximo son 1500 caracteres' 
              }
            ]}
            style={{ marginBottom: '3px' }}
          >
            <Input.TextArea 
              rows={4} 
              maxLength={1500} // Evita que el usuario escriba más de 1500
              showCount       // Muestra un contador visual (ej: 120/1500)
              placeholder={t('view.forms.fields.details.placeholder') as string} 
            />
          </Form.Item>
        </Form>     
        <Button
          onClick={() => {
              Modal.confirm({
                  title: 'Cambio de mensaje',
                  content: '¿Confirmas el cambio del mensaje?',
                  okText: t('dictionary.confirm'),
                  cancelText: t('dictionary.cancel'),
                  onOk: scheduleDateForm.submit
              })
          }}
          type="text">
          <CheckOutlined />
        </Button>
      </div>
    )
}







